<template>
    <sidebar
        :data="data"
        :logo-url="urlGenerator('/')"
        :logo-src="urlGenerator(logoUrl)"
        :logo-icon-src="urlGenerator(iconUrl)"
    />
</template>

<script>
import {urlGenerator} from "../../helpers/AxiosHelper";
import {mapGetters} from "vuex";

export default {
    name: 'DashboardSidebar',
    props: {
        data: {
            required: true
        },
        logo: {
            type: String,
        },
        logoIcon: {
            type: String,
        }
    },
    data() {
        return {
            urlGenerator,
        }
    },
    computed: {
        ...mapGetters({settings: 'settings'}),
        logoUrl() {
            return this.settings?.company_logo
        },
        iconUrl() {
            return this.settings?.company_icon
        }
    }
}
</script>
